/**
 * isValidPassword
 * @function isValidPassword Checks that password meets the minimum requirements
 * @param password Password to be checked
 * @description
 *  - Minimum 8 characters
 *  - One uppercase letter
 *  - One lowercase letter
 *  - One number
 *  - One special character
 */
export const isValidPassword = (password: string) => {
  const regex = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');

  return regex.test(password);
};

export const containsSpecialCharacters = (password: string) => {
  const regex = RegExp('(?=.*[!@#$%^&*])');

  return regex.test(password);
};

export const containsLowercaseCharacters = (password: string) => {
  const regex = RegExp('^(?=.*[a-z])');

  return regex.test(password);
};

export const containsUppercaseCharacters = (password: string) => {
  const regex = RegExp('(?=.*[A-Z])');

  return regex.test(password);
};

export const containsDigits = (password: string) => {
  const regex = RegExp('(?=.*[0-9])');

  return regex.test(password);
};

export const toBase64 = (files: FileList) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = error => reject(error);
  });
